import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const TopHeader = () => {
    const [headerData, setHeaderData] = useState(null);

    useEffect(() => {
        // Fetch data from the API
        fetch('https://yautiktechnology.com/api/headers')
            .then((response) => response.json())
            .then((data) => {
                if (data && data.length > 0) {
                    setHeaderData(data[0]); // Assuming we are using the first item
                }
            })
            .catch((error) => {
                console.error('Error fetching data:', error);
            });
    }, []);

    // If data is not loaded yet, you can show a loading state or return null
    if (!headerData) {
        return <div>Loading...</div>;
    }

    return (
        <div className="topbar-area hidden-md">
            <div className="container">
                <div className="row">
                    <div className="col-lg-2">
                        <div className="logo-part">
                            <Link to="/">
                                <img src={headerData.imageUrl} alt="Logo" />
                            </Link>
                        </div>
                    </div>
                    <div className="col-lg-10 text-right">
                        <ul className="rs-contact-info">
                            <li className="contact-part">
                                <i className="flaticon-location"></i>
                                <span className="contact-info">
                                    <span>Address</span>
                                    {headerData.address}
                                </span>
                            </li>
                            <li className="contact-part">
                                <i className="flaticon-email"></i>
                                <span className="contact-info">
                                    <span>E-mail</span>
                                    <a href={`mailto:${headerData.email}`}>{headerData.email}</a>
                                </span>
                            </li>
                            <li className="contact-part">
                                <i className="flaticon-call"></i>
                                <span className="contact-info">
                                    <span>Phone</span>
                                    {headerData.phoneNumber}
                                </span>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TopHeader;
